import { Component } from '@angular/core';
import { SideMenuComponent } from '../side-menu/side-menu.component';
import { TranslateModule } from '@ngx-translate/core';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-vision-mission',
  standalone: true,
  imports: [SideMenuComponent, TranslateModule],
  templateUrl: './vision-mission.component.html',
  styleUrl: './vision-mission.component.css'
})
export class VisionMissionComponent {

  baseApiUrl = environment.baseApiUrl;
  
}
